<template>
  <div class="title">
    <div class="title__title">{{ title[0] }} <br />{{ title[1] }}</div>
    <div class="title__subtitle">{{ subtitle }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: Array,
      default: () => [],
    },
    subtitle: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;700&display=swap");
@import url("http://fonts.cdnfonts.com/css/gfs-didot");

.title {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  position: relative;
  &__title {
    font-family: GFS Didot;
    font-size: 48px;
    line-height: 60px;
    color: #fff;
    transform: translate(5px, 0);
    text-align: end;
    @media (min-width: 768px) {
      transform: translate(15px, 0);
      font-size: 144px;
      line-height: 180px;
    }
    @media (min-width: 1200px) {
      transform: translate(20px, 0);
      font-size: 194px;
      line-height: 242px;
    }
  }
  &__subtitle {
    font-family: Noto Sans JP;
    font-weight: 100;
    font-size: 13px;
    line-height: 19px;
    color: #000;
    position: absolute;
    right: 8px;
    top: 48px;
    @media (min-width: 768px) {
      font-size: 36px;
      line-height: 52px;
      top: 144px;
      right: 18px;
    }
    @media (min-width: 1200px) {
      font-size: 48px;
      line-height: 70px;
      top: 194px;
      right: 24px;
    }
  }
}
</style>
